export const SET_PAGINATION = "SET_PAGINATION";

const pageReducer = (state = { page: 0, limit: 10 }, action) => {
  switch (action.type) {
    case "SET_PAGINATION":
      return {
        ...state,
        page: action.payload.page,
        limit: action.payload.limit,
      };
    default:
      return state;
  }
};

export default pageReducer;
